import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportDelivery = ({
  onDownload,
  isGenerating,
  canGenerate
}) => {
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-950/30 dark:to-blue-900/20 rounded-lg border-2 border-blue-200 dark:border-blue-800 p-4 md:p-6 shadow-lg">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Download" size={20} className="text-blue-600 dark:text-blue-400" />
          Download Report
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Generate and download the comparison report as a PDF file
        </p>
        <Button
          variant="outline"
          onClick={onDownload}
          disabled={!canGenerate || isGenerating}
          loading={isGenerating}
          iconName="Download"
          iconPosition="left"
          fullWidth
          className="border-2 border-blue-600 dark:border-blue-500 hover:border-blue-700 dark:hover:border-blue-400"
        >
          Download PDF Report
        </Button>
      </div>
      {!canGenerate && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground mb-1">
                Report Generation Requirements
              </p>
              <p className="text-xs text-muted-foreground">
                Please select at least one offer to generate the comparison report.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportDelivery;